module.exports = __webpack_public_path__ + "static/media/due-port07.f05f9ac9.jpg";